export default "__VITE_ASSET__BWjwqlC7__"